import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BsGridFill } from "react-icons/bs";
import { FaRegListAlt } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { RiLockPasswordLine, RiLogoutCircleLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { logout } from "store/features/userSlice";

function SideBar({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    dispatch(logout());
    toast.success("Logged out successfully");
    navigate("/");
  };

  const SideLink = [
    { name: "Dashboard", link: "/dashboard", icon: BsGridFill },
    { name: "My Orders", link: "/dashboard/listoforders", icon: FaRegListAlt },
    { name: "Update Profile", link: "/dashboard/profile", icon: FiSettings },
    // {
    //   name: "Change Password",
    //   link: "/dashboard/password",
    //   icon: RiLockPasswordLine,
    // },
  ];

  const active = "bg-yellowstar text-darkbg";
  const hover =
    "hover:border hover:border-yellowstar hover:text-yellowstar hover:animate-neonFlicker";
  const inActive =
    "rounded font-medium text-sm transition-all duration-300 flex gap-3 items-center p-4";

  return (
    <div className="bg-darkbg text-white pt-24 px-4 min-h-screen">
      <div className="container mx-auto px-2">
        <div className="xl:grid grid-cols-8 gap-10 items-start py-6">
          {/* 🔥 Sidebar Animation */}
          <motion.div
            initial={{ x: -60, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="lg:sticky top-28 col-span-2 bg-navy p-6 rounded-md shadow-lg"
          >
            {SideLink.map((item, i) => (
              <NavLink
                key={i}
                to={item.link}
                end={item.link === "/dashboard"}
                className={({ isActive }) =>
                  `${inActive} ${isActive ? active : hover}`
                }
              >
                <item.icon className="text-lg" />
                <p>{item.name}</p>
              </NavLink>
            ))}

            <button
              onClick={logoutHandler}
              className={`${inActive} ${hover} w-full `}
            >
              <RiLogoutCircleLine className="text-lg" />
              <p>Log Out</p>
            </button>
          </motion.div>

          {/* 🔥 Content Animation */}
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
            className="col-span-6 rounded-md"
          >
            {children}
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
